<template>
    <div class="picker phoneFill"
        :class="mustFlag">
        <h6><span></span>手机验证</h6>
        <div class="text">
            <input 
                type="tel" 
                placeholder="请输入手机号" 
                ref="phone" 
                maxlength="11"
                v-model.trim="phonenum"
                @change="getMessNum"
            >
        </div>
        <em class="btn_getcode" @click="getMess" :class="getClass">{{btnMess}}</em>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getCodeNum} from '../api/request.js'
    export default {
        props: ["mustFlag"],
        data () {
            return {
                phoneNum : '',
                getClass : '' ,
                btnMess : '获取验证码',
                second : 60,
                responseId : '' ,
                phonenum : ''
            }
        },
        methods: {
            settime(){
                if(this.second > 0){
                    this.getClass = 'un'
                    this.second -= 1
                    this.btnMess = this.second  +'秒后获取'
                    setTimeout(() => {
                        this.settime()
                    }, 1000);
                }else{
                    this.btnMess = '获取验证码'
                    this.second = 60
                    this.getClass = ''
                }
            },
            async getMess(){
                this.phoneNum = this.$refs.phone.value
                if(this.phoneNum == ''){
                    this.$toast('请输入手机号')
                    return
                }
                var phoneReg = /^1[2|3|4|5|6|7|8|9|][0-9]{9}$/;  
                //电话  
                if (!phoneReg.test(this.phoneNum)) {  
                    this.$toast('请输入正确的手机号'); 
                    return false 
                } 
                if(this.getClass == 'un'){
                    return
                }
                let phone = this.phoneNum
                let source = "app"
                let res = await getCodeNum(phone , source) 
                if(res.code == 0){
                    this.settime();
                    this.responseId = res.data
                    this.$emit('transMess' , ['phonenum' , this.phonenum , 'responseid' , this.responseId])
                }else{
                    this.$toast('验证码获取失败，请重新获取')
                }
            },
            getMessNum(){
                this.$emit('transMess' , ['phonenum' , this.phonenum , 'responseid' , this.responseId])
            }
        }
    }
</script>

<style scoped>
    .btn_getcode{
        display: block;
        margin-right: 15px;
        float: right;
        height: 54px;
        line-height: 55px;
        font-family: "PingFangSC-Regular";
        font-size: 15px;
        color: #FC542D;
    }
    .btn_getcode.un{
        color: #999;
    }
</style>


// WEBPACK FOOTER //
// src/components/PhoneFill/PhoneFill.vue